import React, {Fragment} from "react";

export default function Base({}) {
	return <Fragment><g transform="translate(-1,-1) scale(1)"><path fill="none" d="M51,16c-19.299,0-35,15.701-35,35s15.701,35,35,35s35-15.701,35-35S70.299,16,51,16z"/><path d="M51,1C23.387,1,1,23.387,1,51s22.387,50,50,50s50-22.387,50-50S78.613,1,51,1z M51,86c-19.299,0-35-15.701-35-35   s15.701-35,35-35s35,15.701,35,35S70.299,86,51,86z"/></g></Fragment>
}